import { render, staticRenderFns } from "./achievementDialog.vue?vue&type=template&id=9d55e856&scoped=true"
import script from "./achievementDialog.vue?vue&type=script&lang=js"
export * from "./achievementDialog.vue?vue&type=script&lang=js"
import style0 from "./achievementDialog.vue?vue&type=style&index=0&id=9d55e856&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d55e856",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d55e856')) {
      api.createRecord('9d55e856', component.options)
    } else {
      api.reload('9d55e856', component.options)
    }
    module.hot.accept("./achievementDialog.vue?vue&type=template&id=9d55e856&scoped=true", function () {
      api.rerender('9d55e856', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/details/comps/achievementDialog.vue"
export default component.exports